module.exports = __webpack_public_path__ + "img/article4-2.2e919f49.jpg";